import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { todayWITA } from "@/lib/constants";
import ReservationForm from "@/components/ReservationForm";
import { ArrowLeft } from "@phosphor-icons/react";

export default function AddReservation() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [submitting, setSubmitting] = useState(false);
  const [practice, setPractice] = useState(null); // eligible practice session detected by the form, or null

  const initial = {
    tanggal_kunjungan: params.get("tanggal") || "",
    jam_kunjungan: params.get("jam") || "",
    petugas_nama: params.get("petugas") || "",
  };

  const submit = async (payload) => {
    setSubmitting(true);
    try {
      // The form is the source of truth for practice detection (onPracticeChange). When a practice
      // session is active it only submits if bookable, and the backend allocates jam + queue and
      // IGNORES any manual jam, so admin cannot override. Otherwise the regular flow is unchanged.
      if (practice) {
        const resp = await api.post("/practice-reservations", payload);
        toast.success(`Sesi praktik ${payload.petugas_nama}: Antrean #${resp.data.queue_number} · perkiraan ${resp.data.estimated_time} (${resp.data.window})`);
        navigate("/reservasi");
        return;
      }
      await api.post("/reservations", payload);
      toast.success("Reservasi berhasil ditambahkan");
      navigate("/reservasi");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="animate-fade-up mx-auto max-w-3xl space-y-6">
      <div>
        <button
          onClick={() => navigate(-1)}
          className="mb-3 flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-[#6A38C7]"
        >
          <ArrowLeft size={18} /> Kembali
        </button>
        <h1 className="font-heading text-3xl font-extrabold tracking-tight text-slate-800">Tambah Reservasi</h1>
        <p className="mt-1 text-sm text-slate-500">Tanggal dibuat otomatis: {todayWITA().split("-").reverse().join("/")}</p>
      </div>
      <ReservationForm initial={initial} onSubmit={submit} submitting={submitting} practiceCheck onPracticeChange={setPractice} />
    </div>
  );
}
